import { render, staticRenderFns } from "./question-ans-schema-markup.vue?vue&type=template&id=6f17e107"
import script from "./question-ans-schema-markup.vue?vue&type=script&lang=js"
export * from "./question-ans-schema-markup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports